// DateRangeFilter.jsx
import React, { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  Stack,
  Button,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const DateRangeFilter = ({ onFilterChange, onReset }) => {
  const [rangeType, setRangeType] = useState("");
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const today = dayjs();

  const handleApply = () => {
    if (dateRange.start && dateRange.end) {
      onFilterChange(
        dateRange.start.format("YYYY-MM-DD"),
        dateRange.end.format("YYYY-MM-DD")
      );
    }
  };

  const handleReset = () => {
    setRangeType("");
    setDateRange({ start: null, end: null });
    onReset?.();
  };

  // useEffect(() => {
  //   if (rangeType === "") {
  //     setDateRange({ start: null, end: null });
  //     onFilterChange(null, null);
  //     return;
  //   }

  //   if (!rangeType || rangeType === "custom") return;

  //   let start, end;

  //   switch (rangeType) {
  //     case "thisMonth":
  //       start = today.startOf("month");
  //       end = today.endOf("month");
  //       break;
  //     case "lastMonth":
  //       start = today.subtract(1, "month").startOf("month");
  //       end = today.subtract(1, "month").endOf("month");
  //       break;
  //     case "last3Months":
  //       start = today.subtract(2, "month").startOf("month");
  //       end = today.endOf("month");
  //       break;
  //     case "last6Months":
  //       start = today.subtract(5, "month").startOf("month");
  //       end = today.endOf("month");
  //       break;
  //     case "last12Months":
  //       start = today.subtract(11, "month").startOf("month");
  //       end = today.endOf("month");
  //       break;
  //     default:
  //       return;
  //   }

  //   setDateRange({ start, end });
  //   onFilterChange(start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD"));
  // }, [rangeType]);

  useEffect(() => {
  if (rangeType === "") {
    setDateRange({ start: null, end: null });
    onFilterChange(null, null);
    return;
  }

  if (!rangeType || rangeType === "custom") return;

  let start, end;
  const today = dayjs();

  switch (rangeType) {
    case "thisMonth":
      start = today.startOf("month");
      end = today;
      break;

    case "lastMonth":
      start = today.subtract(1, "month").startOf("month");
      end = today.subtract(1, "month").endOf("month");
      break;

    case "last3Months":
      start = today.subtract(3, "month").startOf("month");
      end = today.subtract(1, "month").endOf("month");
      break;

    case "last6Months":
      start = today.subtract(6, "month").startOf("month");
      end = today.subtract(1, "month").endOf("month");
      break;

    case "last12Months":
      start = today.subtract(12, "month").startOf("month");
      end = today.subtract(1, "month").endOf("month");
      break;

    default:
      return;
  }

  setDateRange({ start, end });
  onFilterChange(start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD"));
}, [rangeType]);


  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        justifyContent: "right",
        flexWrap: "wrap", marginRight:"10px"
      }}
    >
              {rangeType !== "custom" && (
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <Select
          displayEmpty
          value={rangeType}
          onChange={(e) => setRangeType(e.target.value)}
          sx={{fontSize:"12px"}}
        >
          <MenuItem value="">No Filter (All Data)</MenuItem>
          {/* <MenuItem value="thisMonth">This Month</MenuItem> */}
          <MenuItem value="lastMonth">Last Month</MenuItem>
          <MenuItem value="last3Months">Last 3 Months</MenuItem>
          <MenuItem value="last6Months">Last 6 Months</MenuItem>
          <MenuItem value="last12Months">Last 12 Months</MenuItem>
          <MenuItem value="custom">Custom Range</MenuItem>
        </Select>
      </FormControl>
              )}
      {rangeType === "custom" && (
        <LocalizationProvider dateAdapter={AdapterDayjs} sx={{fontSize:"12px"}}>
          <Stack direction="row" spacing={1} alignItems="center">
            <DatePicker sx={{fontSize:"12px"}}
              label="Start Date"
              value={dateRange.start}
              maxDate={today}
              onChange={(v) => setDateRange({ ...dateRange, start: v })}
              slotProps={{
                textField: {
                  size: "small",
                  sx: { width: 150 },
                },
              }}
            />
            <DatePicker
              label="End Date"
              value={dateRange.end}
              minDate={dateRange.start || undefined}
              maxDate={today}
              onChange={(v) => setDateRange({ ...dateRange, end: v })}
              slotProps={{
                textField: {
                  size: "small",
                  sx: { width: 150 },
                },
              }}
            />

            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleApply}
              disabled={!dateRange.start || !dateRange.end}
              sx={{ textTransform: "none", fontWeight: 500 }}
            >
              Apply
            </Button>

            <Button
              variant="outlined"
              color="secondary"
              size="small"
              onClick={handleReset}
              sx={{ textTransform: "none", fontWeight: 500 }}
            >
              Reset
            </Button>
          </Stack>
        </LocalizationProvider>
      )}
    </Box>
  );
};

export default DateRangeFilter;
